/* @ngInject */

export default ($mdUtil, $timeout) => {
  const validate = (ctrl, scope) => {
    scope.stEmailValidationMessage = '';
    ctrl.$setValidity('isValid', true);
  };
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      stEmailValidationMessage: '='
    },
    link: (scope, element, attrs, ctrl) => {
      $timeout(() => {
        // validate(ctrl, scope, ctrl.$modelValue);
        element.bind(
          'keydown keypress',
          $mdUtil.debounce(() => validate(ctrl, scope, ctrl.$modelValue), 1500)
        );
      });
    }
  };
};
